import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { useNavigate } from "react-router-dom";
// import format from 'date-fns/format';

const LeftTable = ({ leftTableData, setSelectedItemsInLeft, leftTableRowSelection, setLeftTableRowSelection, rightTableData, cmsData }) => {
    const tableInstanceRef = useRef(null);

    const fetchThoughtLeadershipDetailsCMSLabel=(key)=>{
        if(cmsData?.Components && cmsData.Components["ThoughtLeadershipDetails"]){
           const ThoughtLeadershipDetailsLabel=cmsData?.Components["ThoughtLeadershipDetails"];
              return returnLabel(ThoughtLeadershipDetailsLabel?.Labels, key)
        }
        return '';
    }
    
    const returnLabel = (labelArray=[], key) => {
          return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: "ClientAccountName",
                header: fetchThoughtLeadershipDetailsCMSLabel('ThoughtLeadershipDetails.ClientAccountName'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.PlaceholderClientAccountName") }
            },
        ],
        []
    );

    useEffect(() => {
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        // console.log("tl-selected:", selectedRowObjList)
        setSelectedItemsInLeft(selectedRowObjList)
    }, [leftTableRowSelection])

    const [idsTranferedToRight, setIdsTranferedToRight] = useState([])
    useEffect(() => {
        if (!!rightTableData) {
            const list = rightTableData.map((item) => {
                return item.Id
            })
            setIdsTranferedToRight(list)
        }
    }, [rightTableData])

    return (
        <Fragment>
            <MaterialReactTable
                tableInstanceRef={tableInstanceRef}
                columns={columns}
                data={leftTableData}
                layoutMode="grid"
                enableGlobalFilter={false}
                enableDensityToggle={false}
                initialState={{
                    density: 'compact',
                    showColumnFilters: true
                }}
                enableRowSelection={(row) => {
                    // console.log("roe", row.original)
                    //return !idsTranferedToRight.includes(row.original.Id)
                    return (!row.original.disableOption && !idsTranferedToRight.includes(row.original.Id)) //disable selection of tranfered row;
                }}
                getRowId={(originalRow) => originalRow.Id} //give each row a more useful id
                onRowSelectionChange={setLeftTableRowSelection} //connect internal row selection state to your own
                state={{ rowSelection: leftTableRowSelection }}
                enableStickyHeader
                muiTableContainerProps={{
                    sx: {
                        height: { sx: 200, sm: 300, md: 500 },
                    }
                }}
            />
        </Fragment>

    );
};

export default LeftTable;
